import { runGqlMutation } from "gqlClient";
import { Uploader } from "./multipart-upload/Uploader";
import { extractGQLError } from "./PatternGraphQLError";
import { BeginDocumentUploadDocument, CompleteCaseDocumentUploadDocument } from "generated/graphql";
import { MultipartUpload, UploadPartInput } from "./multipart-upload/multipart-upload.types";

export default class UploaderClassImpl extends Uploader {
  async sendBeginUpload() {
    try {
      const response = await runGqlMutation(BeginDocumentUploadDocument, {
        caseId: this.caseId,
        name: this.file.name,
        contentLength: this.file.size,
        contentType: this.file.type,
      });
      return this.onBeginUploadSuccess(response.case.beginDocumentUpload);
    } catch (e) {
      throw this.onBeginUploadFailure(extractGQLError(e)?.status ?? 500);
    }
  }

  async sendPartComplete(
    upload: MultipartUpload,
    partInputs: UploadPartInput[],
    preserveSectionStateForSections: number[]
  ) {
    try {
      await runGqlMutation(CompleteCaseDocumentUploadDocument, {
        caseId: this.caseId,
        uploadId: upload.uploadId,
        preIntakeId: upload.preintakeId,
        parts: partInputs,
        preserveSectionStateForSections,
      });
      this.onPartCompleteSuccess();
    } catch (e) {
      const err = extractGQLError(e);
      this.onPartCompleteFailure(err);
      return Promise.reject(e);
    }
  }
}
